var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseLanding',{attrs:{"is-mobile":_vm.isMobile,"is-msg-hidden":_vm.isMsgHidden,"msg-content":_vm.msgContent,"msg-subtitle":_vm.msgSubTitle,"msg-title":_vm.msgTitle,"landing-page":_vm.landingPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }